import { FarmRiskType, InlandMarineTypes, LiabilityType, lookupsJson } from '@ourbranch/lookups';

const allConstructionTypeIds = lookupsJson.farm.agriculturalConstructionType.map((ct) => ct.id);

export default {
  spinner: 'branch',
  featureFlags: {
    applicantDateOfBirthAtNewOffer: false,
    // NI mailing-address state must match the agent's licensed states. Branch-only — farm
    // carriers (Forreston/Oakwood/CFM) relax this and enforce per-location instead. (#30876)
    enforceLicensedStateOnNamedInsured: true
  },
  discounts: {
    hasFutureEffectiveDateDiscount: true,
    hasAdvanceQuoteDiscount: true,
    hasMultilineDiscount: true,
    hasPaperlessDiscount: true
  },
  farm: {
    IL: {
      liabilityExtensions: {
        rented: {
          [LiabilityType.Personal]: { locations: true, residences: true, structures: true },
          [LiabilityType.Commercial]: { locations: true, residences: true, structures: true }
        },
        occupied: {
          [LiabilityType.Personal]: { locations: true, residences: true },
          [LiabilityType.Commercial]: { locations: true, residences: true }
        },
        assets: {
          [LiabilityType.Personal]: { atv: true, golfCart: true, unmannedAircraft: true, boat: true },
          [LiabilityType.Commercial]: { atv: true, golfCart: true, unmannedAircraft: true, boat: true }
        }
      },
      risks: {
        [FarmRiskType.Fo3]: {
          hiddenCoverages: []
        },
        [FarmRiskType.Fo4]: {
          hiddenCoverages: [],
          allowedOptions: {
            inlandMarineItemTypes: [
              InlandMarineTypes.BoatDock,
              InlandMarineTypes.Boats,
              InlandMarineTypes.CoinCollection,
              InlandMarineTypes.FineArts,
              InlandMarineTypes.Furs,
              InlandMarineTypes.GolfEquipment,
              InlandMarineTypes.GolfCarts,
              InlandMarineTypes.Guns,
              InlandMarineTypes.Jewelry,
              InlandMarineTypes.LawnMowers,
              InlandMarineTypes.MiscellaneousProperty,
              InlandMarineTypes.MusicalInstruments,
              InlandMarineTypes.PersonalTools,
              InlandMarineTypes.Silverware,
              InlandMarineTypes.SportingEquipment,
              InlandMarineTypes.Tack,
              InlandMarineTypes.UnmannedAircraft,
              InlandMarineTypes.Hardware,
              InlandMarineTypes.Software,
              InlandMarineTypes.ScheduledGlass
            ]
          }
        },
        [FarmRiskType.Fo6Structures]: {
          hiddenCoverages: [],
          allowedOptions: {
            constructionTypes: allConstructionTypeIds
          },
          businessRules: {
            buildingClass1MaxAgeYears: 25
          }
        }
      }
    },
    MO: {
      liabilityExtensions: {
        rented: {
          [LiabilityType.Personal]: { locations: true, residences: true, structures: true },
          [LiabilityType.Commercial]: { locations: true, residences: true, structures: true }
        },
        occupied: {
          [LiabilityType.Personal]: { locations: true, residences: true },
          [LiabilityType.Commercial]: { locations: true, residences: true }
        },
        assets: {
          [LiabilityType.Personal]: { atv: true, golfCart: true, unmannedAircraft: true, boat: true },
          [LiabilityType.Commercial]: { atv: true, golfCart: true, unmannedAircraft: true, boat: true }
        }
      },
      risks: {
        [FarmRiskType.Fo3]: {
          hiddenCoverages: []
        },
        [FarmRiskType.Fo4]: {
          hiddenCoverages: []
        },
        [FarmRiskType.Fo6Structures]: {
          hiddenCoverages: [],
          allowedOptions: {
            constructionTypes: allConstructionTypeIds.filter((id) => id !== 'MH')
          },
          businessRules: {
            buildingClass1MaxAgeYears: 25
          }
        },
        [FarmRiskType.Fo6Unscheduled]: {
          hiddenCoverages: []
        },
        [FarmRiskType.Fo6Scheduled]: {
          hiddenCoverages: []
        }
      }
    }
  },
  agencyPortalRoutes: [
    {
      route: 'updates',
      src: 'https://portal.ourbranch.com/ebd/f79f122fa8bb4c6d80d82b4ebbb7e00a',
      title: 'Updates',
      icon: 'portal'
    },
    {
      route: 'underwriting',
      src: 'https://portal.ourbranch.com/ebd/c44e478eb85e4369ba6fa0ab07f26c74',
      title: 'Underwriting',
      icon: 'pen'
    },
    {
      route: 'tools',
      src: 'https://portal.ourbranch.com/ebd/98730a3c688c4c4b86b235ee84ce981e',
      title: 'Resources',
      icon: 'tool'
    },
    {
      route: 'training',
      src: 'https://portal.ourbranch.com/ebd/473fbb17df5f41bb9080164f25205d51',
      title: 'Training',
      icon: 'puzzlePiece'
    },
    {
      route: 'life-insurance',
      src: 'https://portal.ourbranch.com/ebd/81cac880cc984cd5b60fc15d64a8e10c',
      title: 'Life Insurance',
      icon: 'lifeInsurance'
    },
    {
      route: 'claims',
      src: 'https://portal.ourbranch.com/ebd/9a767baeb2c0464c80a847642629e720',
      title: 'Claims',
      icon: 'claim'
    },
    {
      route: 'contact-us',
      src: 'https://portal.ourbranch.com/ebd/29421786cff74f0e806dff853085cf19',
      title: 'Contact Us',
      icon: 'contact'
    }
  ]
};
